import { render, staticRenderFns } from "./SendResetPassword.vue?vue&type=template&id=0b6e5506&scoped=true&"
import script from "./SendResetPassword.vue?vue&type=script&lang=js&"
export * from "./SendResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./SendResetPassword.vue?vue&type=style&index=0&id=0b6e5506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e5506",
  null
  
)

export default component.exports